export default __webpack_public_path__ + "static/media/litho-demo-creative-business.ffe7b8d8.jpg";